module.exports = __webpack_public_path__ + "static/jll.6ed92208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/jll.png
// module id = 2172
// module chunks = 61762850755587